@custom-media --mobile (max-width: 768px);

.searchContainer {
  margin-top: 1em;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;

  @media (--mobile) {
    flex-direction: column;
  }
}

.searchElement {
  flex-basis: 35%;
}
